var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"taste-number",class:_vm.activeColor},[_vm._v("Вкус"),_c('i',[_vm._v(_vm._s(_vm.number))]),_vm._v("из 5")])}
var staticRenderFns = []

export { render, staticRenderFns }